import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyComponent } from './survey.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { ShowAnagComponent } from './show-anag/show-anag.component';
import { MatTableModule } from '@angular/material/table';
import { ShowModule } from './show/show.module';
import { NewModule } from './new/new.module';

@NgModule({
  declarations: [
    SurveyComponent,
    ShowAnagComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,

    ShowModule,
    NewModule,

    TranslateModule,
    FontAwesomeModule,

    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule
  ]
})
export class SurveyModule { }
